module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jNDrg"))).then(() => parcelRequire('9Lwss'));